import { audioPlayerSetup } from '../../components/audio-player/audio-player';

const favouriteArtistsPage = document.querySelector('#favouriteartists');

if (favouriteArtistsPage) {
  audioPlayerSetup();
}
